
import React , {Component,PropTypes} from 'react';


class CommentInput extends Component {
  static propTypes = {
    onSubmit : PropTypes.func
  }
  constructor(){              //设置完state之后，input输入不了任何东西。[React.js认为所有的状态由state控制，state不变，输入控件的value就不变]
    super();
    this.state = {
      username:'',
      content:''
    }
  }

  handleUsernameChange(e){
    this.setState({
      username:e.target.value     //这里设置完才可以输入name
    })
  }

  handleUsernameBlur(e){
    localStorage.setItem('username',e.target.value);
  }

  handleContentChange(e){
    this.setState({
      content:e.target.value     //这里设置完才可以输入content
    })
  }

  handleSubmit(){
    if(this.props.onSubmit) {    //传给父组件
      const {username,content} = this.state;
      this.props.onSubmit({username,content,createdTime:+new Date()})
    }

    this.setState({
      content:''
    })
  }

  componentWillMount(){
    const username = localStorage.getItem('username');
    if(username){
      this.setState({
        username
      })
    }
  }

  componentDidMount(){
    this.refs.commentInput.focus();
  }

  /*
  **受控组件（Controlled Component）：某些元素的 value 值被 React.js 所控制、渲染的组件
  */

  render () {
      return (
        <div className="comment-input">
          <div className="comment-filed">
            <span className="comment-filed-name">用户名：</span>
            <div className="comment-filed-input">
              <input value={this.state.username} onChange={this.handleUsernameChange.bind(this)} onBlur={this.handleUsernameBlur.bind(this)} />
            </div>
          </div>
          <div className="comment-filed">
            <span  className="comment-filed-name">评论内容：</span>
            <div className="comment-filed-input">
              <textarea ref='commentInput' value={this.state.content} onChange={this.handleContentChange.bind(this)} />
            </div>
          </div>
          <div className="comment-filed-button">
            <button onClick={this.handleSubmit.bind(this)}>发布</button>
          </div>
        </div>
      )
  }
}


export default CommentInput;



// WEBPACK FOOTER //
// ./src/CommentInput.js